<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p>I am very grateful to James Dudley-Smith for commenting on the manuscript and to Glenn B. Nesbitt for comments, typing and much else besides.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?6be91f17